/** Inline stroke icons — no icon library, so nothing to load and every glyph
 *  inherits currentColor. Sized 1em unless told otherwise. */
type P = { size?: number; className?: string };

const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
});

export const IcHome = ({ size = 22 }: P) => (
  <svg {...base(size)}>
    <path d="M3 10.5 12 3l9 7.5" />
    <path d="M5 9.5V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5" />
  </svg>
);

export const IcPeople = ({ size = 22 }: P) => (
  <svg {...base(size)}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" />
    <path d="M16 5.3a3.2 3.2 0 0 1 0 6" />
    <path d="M18 14.9c2 .7 3 2.4 3 5.1" />
  </svg>
);

export const IcCalendar = ({ size = 22 }: P) => (
  <svg {...base(size)}>
    <rect x="3" y="5" width="18" height="16" rx="3" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </svg>
);

export const IcMore = ({ size = 22 }: P) => (
  <svg {...base(size)}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);

export const IcPlus = ({ size = 26 }: P) => (
  <svg {...base(size)} strokeWidth={2.2}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const IcBell = ({ size = 21 }: P) => (
  <svg {...base(size)}>
    <path d="M18 8a6 6 0 1 0-12 0c0 6-2 7-2 7h16s-2-1-2-7" />
    <path d="M10.3 20a2 2 0 0 0 3.4 0" />
  </svg>
);

export const IcSearch = ({ size = 21 }: P) => (
  <svg {...base(size)}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.6-3.6" />
  </svg>
);

export const IcFilter = ({ size = 21 }: P) => (
  <svg {...base(size)}>
    <path d="M4 6h16M7 12h10M10 18h4" />
  </svg>
);

export const IcWhatsapp = ({ size = 19 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 18.15a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.23 8.24-8.23a8.2 8.2 0 0 1 8.23 8.24c0 4.54-3.69 8.23-8.23 8.23Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.79.97-.14.16-.29.18-.54.06-.25-.13-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.5.11-.11.25-.29.37-.44.13-.15.17-.25.25-.42.09-.16.04-.31-.02-.43-.06-.13-.56-1.35-.77-1.84-.2-.48-.4-.42-.55-.43h-.47c-.16 0-.43.06-.65.31-.22.25-.86.84-.86 2.05s.88 2.38 1 2.54c.12.17 1.73 2.64 4.19 3.7.59.26 1.04.41 1.4.52.59.19 1.12.16 1.54.1.47-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.1-.22-.16-.47-.28Z" />
  </svg>
);

export const IcPhone = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <path d="M6.5 3h3l1.5 4-2 1.5a12 12 0 0 0 5.5 5.5L16 12l4 1.5v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 4 6.2 2 2 0 0 1 6 4Z" />
  </svg>
);

export const IcClock = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 1.8" />
  </svg>
);

export const IcMail = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <rect x="3" y="5.5" width="18" height="13" rx="2.5" />
    <path d="m3.6 7 8.4 5.6L20.4 7" />
  </svg>
);

export const IcSpark = ({ size = 14 }: P) => (
  <svg {...base(size)} strokeWidth={1.6}>
    <path d="M12 3.5 13.6 9l5.4 1.6-5.4 1.7L12 17.6l-1.6-5.3L5 10.6 10.4 9Z" />
  </svg>
);

export const IcChevron = ({ size = 16 }: P) => (
  <svg {...base(size)}>
    <path d="m14 6-6 6 6 6" />
  </svg>
);

export const IcUserPlus = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <circle cx="9.5" cy="8" r="3.3" />
    <path d="M3.5 20c0-3.3 2.7-5.6 6-5.6 1.3 0 2.5.34 3.5.95" />
    <path d="M18 14v6M15 17h6" />
  </svg>
);

export const IcForm = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <rect x="5" y="3.5" width="14" height="17" rx="2.5" />
    <path d="M9 8.5h6M9 12.5h6M9 16.5h3" />
  </svg>
);

export const IcAlert = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <path d="M12 4.5 21 19.5H3Z" />
    <path d="M12 10v4M12 17h.01" />
  </svg>
);

export const IcMerge = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <path d="M7 20V9a4 4 0 0 1 4-4h2" />
    <path d="M17 20v-6a4 4 0 0 0-4-4h-2" />
    <path d="m11 3 2.2 2L11 7" />
  </svg>
);

export const IcCheck = ({ size = 19 }: P) => (
  <svg {...base(size)} strokeWidth={2.1}>
    <path d="m5 12.5 4.5 4.5L19 7" />
  </svg>
);

export const IcWallet = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <rect x="3" y="6" width="18" height="13" rx="3" />
    <path d="M3 10h18M16.5 14.5h.01" />
  </svg>
);

export const IcInbox = ({ size = 21 }: P) => (
  <svg {...base(size)}>
    <path d="M3 13.5 5.4 5.6A2 2 0 0 1 7.3 4.2h9.4a2 2 0 0 1 1.9 1.4L21 13.5" />
    <path d="M3 13.5h5l1.2 2.4h5.6L16 13.5h5v4.3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
  </svg>
);

export const IcTent = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <path d="M12 4 3.5 19h17Z" />
    <path d="M12 4v15M8.5 19l3.5-6 3.5 6" />
  </svg>
);

export const IcDots = ({ size = 18 }: P) => (
  <svg {...base(size)} strokeWidth={2.2}>
    <circle cx="12" cy="5.5" r="0.6" />
    <circle cx="12" cy="12" r="0.6" />
    <circle cx="12" cy="18.5" r="0.6" />
  </svg>
);

export const IcTrash = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <path d="M4 7h16M9.5 7V5h5v2M6.5 7l1 13h9l1-13" />
  </svg>
);

export const IcSeed = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <path d="M12 20v-7" />
    <path d="M12 13c0-3.9 3.1-7 7-7 0 3.9-3.1 7-7 7Z" />
    <path d="M12 16c0-2.8-2.2-5-5-5 0 2.8 2.2 5 5 5Z" />
  </svg>
);

export const IcSettings = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 3v2.2M12 18.8V21M4.2 7.5l1.9 1.1M17.9 15.4l1.9 1.1M4.2 16.5l1.9-1.1M17.9 8.6l1.9-1.1" />
  </svg>
);

export const IcLogout = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <path d="M14 4h3.5A1.5 1.5 0 0 1 19 5.5v13a1.5 1.5 0 0 1-1.5 1.5H14" />
    <path d="M10 8 6 12l4 4M6 12h9" />
  </svg>
);

/** A tray with an arrow going into it — the shape every interface uses for
 *  "save this to your device". */
export const IcDownload = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <path d="M12 3v11M8.5 10.5 12 14l3.5-3.5" />
    <path d="M5 16v2.5A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5V16" />
  </svg>
);

/** A box with a lid — "put it away", not "destroy it". */
export const IcArchive = ({ size = 19 }: P) => (
  <svg {...base(size)}>
    <rect x="3.5" y="4.5" width="17" height="4" rx="1" />
    <path d="M5 8.5v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-10M10 12.5h4" />
  </svg>
);
